/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Header_Trending_RoadInputs */

const en_header_trending_road = /** @type {(inputs: Header_Trending_RoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The private-property meme`)
};

/**
* | output |
* | --- |
* | "The private-property meme" |
*
* @param {Header_Trending_RoadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const header_trending_road = /** @type {((inputs?: Header_Trending_RoadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Header_Trending_RoadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_header_trending_road(inputs)
});
export { header_trending_road as "header.trending.road" }